/**
 * @generated SignedSource<<f03faf79cd79066c9ca07d112d710186>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type notificationSection$data = {
  readonly name: string;
  readonly " $fragmentType": "notificationSection";
};
export type notificationSection$key = {
  readonly " $data"?: notificationSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"notificationSection">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "notificationSection"
};

(node as any).hash = "f80b278cf3a016240fe57eff4f3a8e6b";

export default node;
